import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import { CardStack } from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { collaboratorSummaryShape } from 'Workspace/types/collaborator';
import SharingDialog from 'Workspace/components/SharingDialog';
import { commandWorkspacePluginPermissionGrant } from 'containers/ConnectionManager/actions';

import messages from './messages';
import { SharingWrapper } from './styles';

const PluginSharingCard = ({ collaborators, pluginId, onRevoke, theme }) => (
  <CardStack
    icon="duotoneDetails"
    title={intl.formatMessage(messages.sharingTitle)}
    description={intl.formatMessage(messages.sharingDescription)}
  >
    <SharingWrapper>
      {intl.formatMessage(messages.addPeopleTitle)}
      <SharingDialog
        avatarBorderColor={theme['color.surface']}
        sharedWith={collaborators}
        refId={pluginId}
        hasStorageInPermissionGrant
        permissionGrantCommand={commandWorkspacePluginPermissionGrant}
        handleDelete={onRevoke}
      />
    </SharingWrapper>
  </CardStack>
);

PluginSharingCard.propTypes = {
  collaborators: collaboratorSummaryShape,
  pluginId: PropTypes.string,
  onRevoke: PropTypes.func,
  theme: PropTypes.object,
};

export default withTheme(PluginSharingCard);
